import { render, staticRenderFns } from "./addsubcategory.vue?vue&type=template&id=1399f733"
import script from "./addsubcategory.vue?vue&type=script&lang=js"
export * from "./addsubcategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports